import { useOutletContext } from "react-router-dom";

import { type Node } from "@/client/features/nodes/nodes-api";

/**
 * Shared across a node's tabs (Overview / Console & power / Redfish / Policy) so
 * each tab renders from a single load in the layout instead of refetching.
 * Provided by the node layout via <Outlet context> and read with useNodeTab.
 */
export interface NodeTabContext {
  node: Node;
  isAdmin: boolean;
  isStaffView: boolean;
  refreshPublicIp: () => void;
}

export function useNodeTab(): NodeTabContext {
  return useOutletContext<NodeTabContext>();
}
